import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from "@angular/core";
import { ExteriorNodeLabelModel, LabelStyle, Rect, SimpleLabel, SimpleNode, Size } from "@yfiles/yfiles";
import { NodeService } from "../../model-services/node.service";
import { Linqset } from "../../common/linqset-model";
import { DragAndDropPanel } from "../../canvas/palette/drag-drop-panel";
import { LABEL_TYPES } from "../../model-services/model-item-enums";
import { LinqNodeStyle } from "../../canvas/styles/linq-node-style";
import { NodeStyleSettings } from "../../ui-components/svgs/node-svgs";

// the walkthrough's palette: the nodes of the model being built, in order. Only the next one can be dragged; the
// walkthrough's guide says what to do with it
@Component({
    selector: 'app-onboarding-palette',
    templateUrl: 'onboarding-palette.html',
    styleUrls: ['onboarding-palette.css'],
    standalone: false
})
export class OnboardingPaletteComponent implements OnChanges, AfterViewInit {
    @Input() linqset:Linqset
    @Input() start:number
    @Input() end:number
    @Input() canSelect:boolean

    // this palette's own element, rather than a page-wide id
    @ViewChild('dndPanel', {static: true}) panelElement:ElementRef<HTMLElement>

    dragAndDropPanel:DragAndDropPanel

    constructor(private nodeService:NodeService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.linqset && this.start >= 0 && this.end >= 0) {
            this.createPanel()
        }
    }

    ngAfterViewInit(): void {
        if (!this.dragAndDropPanel && this.linqset && this.start >= 0 && this.end >= 0) this.createPanel()
    }

    createPanel() {
        const element = this.panelElement?.nativeElement
        if (!element) return
        if (!this.dragAndDropPanel) {
            this.dragAndDropPanel = new DragAndDropPanel(element)
        }

        this.dragAndDropPanel.clearPanel()
        this.dragAndDropPanel.copyNodeLabels = false
        this.dragAndDropPanel.maxItemWidth = 300

        this.dragAndDropPanel.populatePanel(this.createDnDPanelItems())
    }

    createDnDPanelItems() {
        const items = []
        for (let i=this.start; i < this.end; i ++) {
            const n = this.linqset.nodes[i]
            const labels = [new SimpleLabel({text:n.name, layoutParameter:ExteriorNodeLabelModel.BOTTOM, style:new LabelStyle(), preferredSize: new Size(100, 50), tag:{type:LABEL_TYPES.NODE_NAME}})]

            const node = new SimpleNode({
                layout: new Rect(0, 0, 35, 35),
                style: new LinqNodeStyle(new NodeStyleSettings(n)),
                tag: {node: n, index:i },
                labels: labels
            })
            const next = this.canSelect && i === this.start
            items.push({ modelItem: node, tooltip: next ? (n.description || n.name) : `${n.name}: comes later in the walkthrough`, disabled: !next})
        }
        return items
    }
}
